import { ACTIONS as cueBoardActions } from 'actions/cue-board';

const initialState = {
  isOpen: false,
};

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === cueBoardActions.SHOW_OR_HIDE_BOARD) {
    return {
      ...state,
      isOpen: payload,
    };
  }

  return state;
}
